import { ActionButton } from '@/shared/ui/action-button';
import { useTranslation } from 'react-i18next';

interface CalendarFooterProps {
  handleCancel: () => void;
  handleApply: () => void;
}

export function CalendarFooter({ handleCancel, handleApply }: CalendarFooterProps) {
  const { t } = useTranslation();
  return (
    <div className="flex justify-end">
      <ActionButton intent="dismiss" size="sm" onClick={handleCancel} className="mr-2">
        {t('gen.cancel.label')}
      </ActionButton>
      <ActionButton intent="primary" size="sm" onClick={handleApply}>
        {t('common.apply')}
      </ActionButton>
    </div>
  );
}
